import React, { useState, useEffect, useContext, useMemo, useCallback } from "react";
import {IndividualRow} from './IndividualRow'


// 3. Tableau d'individus
export const IndividualsTable = React.memo(({ 
  individuals, 
  selectedIndividuals, 
  selectAll,
  onSelectAll,
  onIndividualSelect,
  onIndividualClick,
  onIndividualDelete,
  sortOrder,
  onSortByDate,
  getTagStyle,
  screenSize = 'desktop'
}) => {
  // Vue Mobile uniquement (cartes)
  if (screenSize === 'mobile') {
    return (
      <div className="space-y-4">
        {/* Header mobile avec sélection et tri */}
        <div className="flex justify-between items-center bg-white p-4 rounded-lg shadow-sm border">
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              onChange={onSelectAll}
              checked={selectAll}
              className="w-4 h-4 text-indigo-600 bg-white border-gray-300 rounded focus:ring-indigo-500 focus:ring-2"
            />
            <span className="text-sm font-medium text-gray-700">Tout sélectionner</span>
          </label>
          
          <button 
            onClick={onSortByDate} 
            className="flex items-center space-x-1 text-sm font-medium text-blue-600 hover:text-blue-800"
          >
            <span>Date</span>
            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
          </button>
        </div>

        {individuals.map((individual) => (
          <IndividualRow
            key={individual._id}
            individual={individual}
            isSelected={selectedIndividuals.includes(individual._id)}
            onSelect={onIndividualSelect}
            onClick={onIndividualClick}
            onDelete={onIndividualDelete}
            getTagStyle={getTagStyle}
            screenSize={screenSize}
          />
        ))}
      </div>
    );
  }

  // Vue Table responsive pour tablette et desktop
  return (
    <div className="overflow-auto rounded-xl mx-3 border border-gray-200">
      <table className="w-full bg-white ">
        <thead className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
          <tr>
            <th className="px-3 py-4 text-left w-12">
              <input
                type="checkbox"
                onChange={onSelectAll}
                checked={selectAll}
                className="w-4 h-4 text-indigo-600 bg-white border-gray-300 rounded focus:ring-indigo-500 focus:ring-2"
              />
            </th>
            <th className="px-2 py-4 text-left text-sm font-semibold text-gray-900 w-80 max-w-80">Profil</th>
            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900 w-72 max-w-72">Contact</th>
            {/* Actions - Masquées sur tablette */}
            {screenSize === 'desktop' && (
              <th className="px-3 py-4 text-center text-sm font-semibold text-gray-900 w-16">Actions</th>
            )}
            {/* Actions sur tablette */}
            {screenSize === 'tablet' && (
              <th className="px-3 py-4 text-center text-sm font-semibold text-gray-900 w-16">Actions</th>
            )}
          </tr>
        </thead>
        
        <tbody>
          {individuals.map((individual) => (
            <IndividualRow
              key={individual._id}
              individual={individual}
              isSelected={selectedIndividuals.includes(individual._id)}
              onSelect={onIndividualSelect}
              onClick={onIndividualClick}
              onDelete={onIndividualDelete}
              getTagStyle={getTagStyle}
              screenSize={screenSize}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
});